const COMPONENT_PREFIX = "taroify-"

export function prefixClassname(component: string) {
  return `${COMPONENT_PREFIX}${component}`
}
